import styled from 'styled-components'

import ListItem from '../../atoms/ListItem'
import Link from '../../atoms/Link/styled'

// TODO: convert to column and make underline grow to width of text like an underline
const Market = styled(ListItem)`
  text-transform: uppercase;

  &:hover ${Link} {
    text-decoration: none;
  }

  ${Link} {
    display: inline-block;
  }

  &:hover::after {
    max-width: 100px;
    transition: max-width 0.5s ease-in-out;
  }

  &::after {
    display: block;
    content: ' ';
    height: 2px;
    width: 100%;
    max-width: 20px;
    background-color: ${props => props.theme.colors.tertiary};
  }
`

export default Market
